import React from 'react';
import { Field, reduxForm } from 'redux-form';
import * as utils from './eventUtils/eventFormUtils.jsx'

class EventForm extends React.Component {

  onSubmit = (formValues) => {
    this.props.onSubmit(formValues);
  }

  render () {
      return (
        <form onSubmit={this.props.handleSubmit(this.onSubmit)} className="ui form error">
          <div className="four wide fields">
              <Field name="event_name" component={utils.renderInput} label= "Event name"/>
             < Field name="event_year" component={utils.renderSelectYear} label= "Year" />

          </div>

          <div className="four wide fields">
              <Field name="event_club" component={utils.renderInput} label= "Club"/>

            <Field name="event_location" component={utils.renderInput} label= "Event location"/>
          </div>
          <div className="four wide fields">
            <div className="field">
              <Field name="event_month" component={utils.renderSelect} label= "Enter month" />
            </div>
            <div className="field">
              <Field name="event_day" component={utils.renderSelectDay} label= "Day of month" />
            </div>
          </div>
          <div className="four wide fields">
              <Field name="event_hour" component={utils.renderSelectHour} label= "Start hour" />
              <Field name="event_min" component={utils.renderSelectMin} label= "Start minute" />
          </div>
          <div className="four wide fields">
            <Field name="event_activation_status" component={utils.renderEventActivation} label= "Activation Status" />
           <Field name="event_registration" component={utils.renderEventRegistration} label= "Registration Opened/Closed" />
          </div>
          <div className="eight wide field">
             <Field name="notes" component={utils.renderTextArea} label= "Notes"/>
          </div>
          <button className="ui button positive">Submit</button>
        </form>
      );
  }
};

const validate = (formValues) => {
    const errors = {};

    if(!formValues.event_location){
      errors.event_location = "You must enter game location";
    }

    if(!formValues.event_name){
      errors.event_name = "You must enter game name";
    }

    if(!formValues.event_day){
      errors.event_day = "You must enter day of month";
    }
    if(!formValues.event_hour){
      errors.event_hour = "You must enter start hour";
    }
    if(!formValues.event_min){
      errors.event_min = "You must enter start minute";
    }

    if(!formValues.event_year){
      errors.event_year = "You must enter year";
    }
    if(!formValues.event_club){
      errors.event_club = "You must enter club name";
    }

    if(!formValues.event_activation_status){
      errors.event_activation_status = "You must enter activation status";
    }

    if(!formValues.event_registration){
      errors.event_registration = "You must select registration state";
    }

    if(!formValues.event_month){
      errors.event_month = "You must enter month";
    }
    return errors;
}

// returns a function and immediately calls that function with EventCreate
export default reduxForm({
  form: 'eventForm',
  validate
})(EventForm);
